import type { Market } from '@backmarket/http-api/src/api-models/Market'
import type { Marketplace } from '@backmarket/http-api/src/api-models/Marketplace'
/** Create marketplace object grouping markets by marketplace code. */
export function createMarketplace(
  market: Market,
  allMarkets: Record<string, Market>,
): Marketplace {
  return {
    marketplaceCode: market.marketplace,
    markets: Object.values(allMarkets).filter((m) => {
      return m.marketplace === market.marketplace
    }),
  }
}
